import keyMirror from "ramda-extension/es/keyMirror";
export const actionTypes = keyMirror({
    REPORT_ERROR: null,
    DISMISS_ERROR: null
});
export const REDUCER_NAME = 'error';
export default {
    actionTypes
};
